export default __webpack_public_path__ + "assets/d515df3016a7cda4f164c903f46628be.woff";